module.exports = {
  CC: 'CC',
  CP: 'CP',
  TED_SAME_OWNERSHIP: 'TED_SAME_OWNERSHIP',
  TED_OTHER_OWNERSHIP: 'TED_OTHER_OWNERSHIP'
};
